import WizardForm from '~/components/WizardForm';
import { Input } from 'antd';
import Section from '~/layouts/Section ';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NameFn } from '~/utils/buildNamePath';

interface Props {
  n: NameFn;
}

const StepReviewComment: FC<Props> = (props) => {
  const { n } = props;
  const { t } = useTranslation('ksaReview');

  return (
    <Section>
      <WizardForm.Item name={n('reviewComment')}>
        <Input.TextArea autoSize={textareaAutoSize} placeholder={t('Enter your comment')} />
      </WizardForm.Item>
    </Section>
  );
};

const textareaAutoSize = { minRows: 2 };

export default StepReviewComment;
